export default "__VITE_ASSET__Dn2Ju8Or__"